import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class SysLogModule {
    constructor() {
        this.sysLogs = [];
        this.count = 0;
        this.axiosError = null;
    }
    setData(sysLogs) {
        this.sysLogs = sysLogs;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.sysLogs;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.sysLog.get(options);
            this.setData(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
        }
    }
}
__decorate([
    State()
], SysLogModule.prototype, "sysLogs", void 0);
__decorate([
    State()
], SysLogModule.prototype, "count", void 0);
__decorate([
    State()
], SysLogModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], SysLogModule.prototype, "setData", null);
__decorate([
    Mutation()
], SysLogModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], SysLogModule.prototype, "setError", null);
__decorate([
    Getter()
], SysLogModule.prototype, "list", null);
__decorate([
    Getter()
], SysLogModule.prototype, "total", null);
__decorate([
    Getter()
], SysLogModule.prototype, "errorList", null);
__decorate([
    Action()
], SysLogModule.prototype, "get", null);
